module.exports = __webpack_public_path__ + "static/ceramic-oval-vase-with-flower_5hx8lx4din-5a3adaa6c53fdfe88a0aa19bb8f4c022.jpg";